module.exports = __webpack_public_path__ + "img/1.173df53a.png";